import { useState } from 'react';
import axios from 'axios';
import { Loader2, ArrowLeft, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AdminForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch {
      setError('Anfrage fehlgeschlagen. Bitte versuche es erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#020817] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <a href="/" className="inline-flex items-center gap-1 select-none">
            <span className="text-2xl font-extrabold text-white uppercase tracking-wide" style={{ fontFamily: 'Outfit, sans-serif' }}>Hosting-</span>
            <span className="text-2xl font-extrabold text-cyan-400 uppercase tracking-wide" style={{ fontFamily: 'Outfit, sans-serif' }}>Community</span>
          </a>
          <p className="text-sm text-slate-500 mt-2">Admin-Bereich</p>
        </div>

        <div className="bg-[#0f172a] border border-slate-800 rounded-2xl p-8">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-12 h-12 bg-cyan-500/10 rounded-full flex items-center justify-center mx-auto">
                <Mail className="w-6 h-6 text-cyan-400" />
              </div>
              <h1 className="text-xl font-bold text-white">E-Mail versendet</h1>
              <p className="text-sm text-slate-400">
                Falls diese Adresse in unserem System existiert, erhältst du einen Link zum Zurücksetzen deines Passworts.
              </p>
              <a
                href="#/admin/login"
                className="inline-flex items-center gap-2 text-sm text-cyan-400 hover:text-cyan-300 transition-colors mt-4"
              >
                <ArrowLeft className="w-4 h-4" /> Zurück zum Login
              </a>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="forgot-password-form">
              <div>
                <h1 className="text-xl font-bold text-white">Passwort vergessen</h1>
                <p className="text-sm text-slate-500 mt-1">Gib deine E-Mail-Adresse ein und wir schicken dir einen Reset-Link.</p>
              </div>

              {error && (
                <div className="px-4 py-2.5 bg-red-500/10 border border-red-500/30 rounded-lg text-sm text-red-400">
                  {error}
                </div>
              )}

              <div className="space-y-1">
                <label className="text-xs font-medium text-slate-400 uppercase tracking-wider">E-Mail</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email"
                  className="w-full px-4 py-2.5 bg-slate-800 border border-slate-700 rounded-lg text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 transition-colors"
                  placeholder="admin@hosting-community.de"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit"
                className="w-full py-2.5 bg-cyan-500 text-slate-950 font-semibold rounded-lg hover:bg-cyan-400 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                Reset-Link senden
              </button>

              <a href="#/admin/login" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 hover:text-slate-300 transition-colors">
                <ArrowLeft className="w-3.5 h-3.5" /> Zurück zum Login
              </a>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
